<!-- Footer start -->
<div class="footer-section">
  <mat-grid-list
    cols="5"
    rowHeight="{{ isHandsetPortrait ? '245px' : '225px' }}"
    gutterSize="15px"
  >
    <mat-grid-tile
      [class.footer-tile]="isHandsetPortrait"
      colspan="{{ isHandsetPortrait ? 5 : 2 }}"
    >
      <div class="footer-content-wrapper">
        <div class="footer-heading-wrapper">
          <a class="" href="/">
            <img alt="Guru Granth Sahib Footer-Logo" src="/assets/images/TGGSP Logo.svg" />
          </a>
        </div>
        <div class="footer-text-wrapper">
          {{ "tagline" | translate }}
          <a class="f-a" [href]="fetchLanguage() != 'en' ? 'info/panjabi/project' : '/info/english/project'"> {{ "tagline1" | translate }} </a>
          {{ "tagline2" | translate }}
        </div>
      </div>
    </mat-grid-tile>
    <mat-grid-tile
      [class.is-mobile]="isHandsetPortrait"
      class="first-footer-tile blank"
      colspan="{{ isHandsetPortrait ? 2 : 1 }}"
    >
      <!-- <mat-list
        class="footer-link-lists margin-top"
        [class.is-mobile]="isHandsetPortrait"
        role="list"
      >
        <mat-list-item role="listitem" class="footer-link-heading">
          {{ "Social" | translate }}
        </mat-list-item>

        <mat-list-item role="listitem" class="footer-link">
          <a href="https://www.facebook.com/TGGSP/" target="_blank">
            {{ "Facebook" | translate }}
          </a>
        </mat-list-item>

        <mat-list-item role="listitem" class="footer-link">
          <a href="https://www.instagram.com/tggsproject/" target="_blank">
            {{ "Instagram" | translate }}
          </a>
        </mat-list-item>

        <mat-list-item role="listitem" class="footer-link">
          <a (click)="goToPage('new-release')" target="_blank">
          {{ "Subscribe" | translate }}</a>
        </mat-list-item>

        <mat-list-item role="listitem" class="footer-link">
          <a href="https://www.tiktok.com/@tggsp" target="_blank">
          {{ "Tik Tok" | translate }}</a>
        </mat-list-item>

        <mat-list-item role="listitem" class="footer-link">
          <a href="https://twitter.com/tggsproject" target="_blank">
          {{ "Twitter" | translate }}</a>
        </mat-list-item>


        <mat-list-item role="listitem" class="footer-link">
          <a href="https://www.youtube.com/watch?v=9E4GsjZJwIE" target="_blank">
          {{ "Youtube" | translate }}</a>
        </mat-list-item>

        <mat-list-item role="listitem" class="footer-link"> </mat-list-item>
      </mat-list> -->
    </mat-grid-tile>
    <div [class.tile]="isHandsetPortrait">
      <mat-grid-tile
      class="middle"
      [class.is-mobile]="isHandsetPortrait"
      [class.footer-tile]="isHandsetPortrait"
      ><mat-list
        class="footer-link-lists"
        role="list"
      >
        <mat-list-item role="listitem" class="footer-link-heading">
          {{ "Project" | translate }}
        </mat-list-item>
        
        <mat-list-item role="listitem" class="footer-link">
          <a [href]="fetchLanguage() != 'en' ? 'info/panjabi/approach' : 'info/english/approach'">
            {{ "approach" | translate }}
          </a>
        </mat-list-item>

        <mat-list-item role="listitem" class="footer-link">
          <a [href]="fetchLanguage() != 'en' ? 'info/panjabi/methodology' : 'info/english/methodology'">
            {{ "Methodology" | translate }}
          </a>
        </mat-list-item>

        <mat-list-item role="listitem" class="footer-link">
          <a [href]="fetchLanguage() != 'en' ? 'info/panjabi/navigation' : 'info/english/navigation'" >
            {{ "Navigation" | translate }}
          </a>
        </mat-list-item>
        <mat-list-item role="listitem" class="footer-link">
         <a target="_blank" href="https://gurugranthsahibdictionary.io"> {{ "dictionary" | translate }} </a>
        </mat-list-item>
  <mat-list-item role="listitem" class="footer-link">
        <a  href="/search"> {{ "Compositions" | translate }} </a>
        </mat-list-item>
       
      </mat-list></mat-grid-tile
    >
    <mat-grid-tile
      [class.footer-tile]="isHandsetPortrait"
      ><mat-list
        class="footer-link-lists"
        role="list"
        [class.is-mobile]="isHandsetPortrait"
      >
        <mat-list-item role="listitem" class="footer-link-heading"
          >{{ "Support" | translate }}</mat-list-item
        >
        <mat-list-item role="listitem" class="footer-link"
          ><a href="https://jobs.sikhri.org/" target="_blank" 
            >{{ "Careers" | translate }}</a
          ></mat-list-item
        >
        <mat-list-item role="listitem" class="footer-link"
          ><a  [href]="fetchLanguage() != 'en' ? 'info/panjabi/content-citation' : 'info/english/content-citation'">{{ "Citation Guide" | translate }}</a
          ></mat-list-item
        >
        <mat-list-item role="listitem" class="footer-link"
          ><a  [href]="fetchLanguage() != 'en' ? 'info/panjabi/corrections' : 'info/english/corrections'">{{ "Corrections" | translate }}</a
          ></mat-list-item
        >
       <!--  <mat-list-item role="listitem" class="footer-link">
          <a href="https://sikhri.org/donate" target="_blank">{{ "Donate" | translate }}</a>
        </mat-list-item> -->
        
      </mat-list></mat-grid-tile
    >
    </div>
   
  </mat-grid-list>
  <!-- <div class="footer-social-links" [class.is-mobile]="isHandsetPortrait"> 
    <ul style="display: inline-flex;">
      <li><a href="https://www.facebook.com/TGGSP/" target="_blank"><img src="assets/images/fb.png"></a></li>
      <li><a href="https://www.instagram.com/tggsproject/" target="_blank"><img src="assets/images/insta.png"></a></li>
      <li><a href="https://twitter.com/tggsproject" target="_blank"><img src="assets/images/twitt.png"></a></li>
      <li><a href="https://www.linkedin.com/company/sikhri" target="_blank"><img src="assets/images/link.png"></a></li>
      <li><a href="https://www.tiktok.com/@tggsp" target="_blank"><img src="assets/images/tiktok.png"></a></li>
      <li><a href="https://www.youtube.com/watch?v=9E4GsjZJwIE" target="_blank"><img src="assets/images/yt.png"></a></li>
    </ul>
  </div> -->
  <mat-grid-list [class.footer-margin]="isHandsetPortrait"
    class="horizontal-footer"
    cols="{{ isHandsetPortrait ? 4 : 7 }}"
    rowHeight="{{ isHandsetPortrait ? '30px' : '26px' }}"
  >
    <mat-grid-tile colspan="{{ isHandsetPortrait ? 4 : 1 }}">
      <div class="footer-link-wrapper">
        <a target="_blank" href="https://sikhri.org/?utm_source=website&utm_campaign=tggsp_website&utm_medium=tggsp&utm_id=15">
          <img alt="Sikhri-logo" src="/assets/images/Sikhri-ImageV2.png" />
        </a>
      </div>
    </mat-grid-tile>
    <mat-grid-tile colspan="{{ isHandsetPortrait ? 2 : 1 }}">
      <div class="footer-link-wrapper">
        <a [href]="fetchLanguage() != 'en' ? 'info/panjabi/privacy-policy' : 'info/english/privacy-policy'">{{ "Privacy_Policy" | translate }}</a>
      </div>
    </mat-grid-tile>

    <mat-grid-tile colspan="{{ isHandsetPortrait ? 2 : 1 }}">
      <div class="footer-link-wrapper">
        <a [href]="fetchLanguage() != 'en' ? 'info/panjabi/copyright' : 'info/english/copyright'">{{ "Copyright" | translate }}</a>
      </div>
    </mat-grid-tile>
    <mat-grid-tile class="terms" colspan="{{ isHandsetPortrait ? 2 : 1 }}"
      ><div class="footer-link-wrapper">
        <a style="white-space: nowrap;"  [href]="fetchLanguage() != 'en' ? 'info/panjabi/terms-of-use' : '/info/english/terms-of-use'">{{ "Terms_of_Service" | translate }}</a>
      </div></mat-grid-tile
    >
    <mat-grid-tile id="contact-us" colspan="{{ isHandsetPortrait ? 2 : 1 }}"
      ><div class="footer-link-wrapper">
        <a [href]="fetchLanguage() != 'en' ? 'info/panjabi/contact-us' : 'info/english/contact-us'">{{ "Contact Us" | translate }}</a>
      </div></mat-grid-tile
    >
    <!-- <mat-grid-tile colspan="{{ isHandsetPortrait ? 2 : 1 }}"
      ><div class="footer-link-wrapper">
        <a href="https://www.instagram.com" target="_blank">Feedback</a>
      </div></mat-grid-tile
    > -->

    <mat-grid-tile colspan="{{ isHandsetPortrait ? 4 : 2 }}">
      <ul style="display: inline-flex;list-style: none;position: relative;bottom: 3px;padding-left: 0rem;">
        <li><a href="https://www.facebook.com/TGGSP/" target="_blank"><img alt="Facebook Icon" src="assets/images/Facebook.webp" height="25" width="25"></a></li>
        <li><a href="https://www.instagram.com/tggsproject/" target="_blank"><img alt="Instagram Icon" src="assets/images/Instagram.webp" height="25" width="25"></a></li>
        <li><a href="https://twitter.com/tggsproject" target="_blank"><img alt="X Icon" src="assets/images/X.webp" height="25" width="25"></a></li>
        <li><a href="https://www.linkedin.com/company/sikhri" target="_blank"><img alt="LinkedIn Icon" src="assets/images/LinkedIn.webp" height="25" width="25"></a></li>
        <li><a href="https://www.tiktok.com/@tggsp" target="_blank"><img alt="TikTok Icon" src="assets/images/TikTok.webp" height="25" width="25"></a></li>
        <li><a href="https://www.youtube.com/@TGGSP" target="_blank"><img alt="YouTube Icon" src="assets/images/YouTube.webp" height="25" width="25"></a></li>
      </ul>
    </mat-grid-tile>
  </mat-grid-list>
</div>
<!-- Footer stop --> 
